import { QueryResult, gql, useMutation, useQuery } from '@apollo/client';
import { useLoginInput } from 'hooks';
import { EpSkill } from 'types/graphql-types';

const GET_LANG_LEVEL_LIST = gql`
  query GetLangLevelList {
    langLevelList
  }
`;

const GET_LANGUAGE_LIST = gql`
  query GetLanguageList {
    languageList
  }
`;

const SAVE_LANGUAGE_SKILLS = gql`
  mutation SaveLanguageSkills($languageSkills: LanguageSkillsInput!) {
    saveLanguageSkills(languageSkills: $languageSkills) {
      login
    }
  }
`;

type UseSaveLanguageSkillsReturnType = {
  mutation: (languages: EpSkill[]) => Promise<void>;
  loading: boolean;
};

export const useSaveLanguageSkills = (): UseSaveLanguageSkillsReturnType => {
  const loginInput = useLoginInput();
  const [saveLanguageSkills, { loading }] = useMutation(SAVE_LANGUAGE_SKILLS, {
    refetchQueries: ['GetEmployee'],
  });

  return {
    loading,
    mutation: async (languages: EpSkill[]) => {
      const opt = {
        variables: { languageSkills: { ...loginInput, languages } },
      };

      await saveLanguageSkills(opt);
    },
  };
};

export const useLangLevelList = (): QueryResult<LangLevelListData> =>
  useQuery<LangLevelListData>(GET_LANG_LEVEL_LIST);

export const useLanguageList = (): QueryResult<LanguageListData> =>
  useQuery<LanguageListData>(GET_LANGUAGE_LIST);

type LanguageListData = {
  languageList: string[];
};

type LangLevelListData = {
  langLevelList: string[];
};
